module.exports = __webpack_public_path__ + "static/img/indexLogo.28da3a43.png";